export class LocaleConstants {
    static ARGENTINA = 'es-AR';
    static BOLIVIA = 'es-BO';
    static BRASIL = 'pt-BR';
    static CHILE = 'es-CL';
    static COLOMBIA = 'es-CO';
    static COSTA_RICA = 'es-CR';
    static ECUADOR = 'es-EC';
    static EL_SALVADOR = 'es-SV';
    static GUATEMALA = 'es-GT';
    static HONDURAS = 'es-HN';
    static MEXICO = 'es-MX';
    static NICARAGUA = 'es-NI';
    static PANAMA = 'es-PA';
    static PARAGUAY = 'es-PY';
    static PERU = 'es-PE';
    static PUERTO_RICO = 'es-PR';
    static REPUBLICA_DOMINICANA = 'es-DO';
    static EEUU = 'en-US';
    static URUGUAY = 'es-UY';
    static VENEZUELA = 'es-VE';
  }
